import React, { useEffect, useMemo, useState } from "react";
import addPlusIcon from "../../img/addPlusIcon.svg";
import moreBtnTableIcon from "../../img/moreButtonTable.svg";
import CreateNewDocuments from "../ReusedComponents/CreateNewDocuments/CreateNewDocuments";
import Search from "../Search/Search";
import { onHandleShowTableMenu } from "../../utils/OnHandleShowTableMenu/OnHandleShowTableMenu";
import TableRowMenu from "../ReusedComponents/TableRowMenu/TableRowMenu";
import CreateDocSetManModal from "../CreateDocSetManModal/CreateDocSetManModal";
import SelectedDocSetMan from "../SelectedDocSetMan/SelectedDocSetMan";
import { findStatusDocument } from "../../utils/FindStatusDocument/FindStatusDocument";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import { axiosPostAddNewMan } from "../../Api/ApiMan/axiosPostAddNewMan";
import { axiosPutUpdateBol } from "../../Api/ApiMan/axiosPutUpdateMan";
import useOnShowEditAddDocsButton from "../../utils/CustomHooks/useOnShowEditAddDocsButton/useOnShowEditAddDocsButton";
import rowBackIcon from "../../img/rowBackMiniIcon.svg";
import { axiosGetRequest } from "../../Api/axiosGetRequest";
import { MANIFEST_GET_LIST } from "../../Api/axios";
import { axiosGetListMan } from "../../Api/ApiMan/axiosGetListMan";
import { filtredArrayBolsSelectedMan } from "../../utils/FiltredArrayBolsSelectedMan/FiltredArrayBolsSelectedMan";

const CargoCaseDocSetMan = (props) => {
  const { activeNoLoadingOrder, cargoCaseDocument, isNewDocCargoCase } = props;

  const [filter, setFilter] = useState("");
  const axiosPrivate = useAxiosPrivate();
  const cargoCaseDocId = cargoCaseDocument[0]?.id;
  const [editDoc, setEditDoc] = useState(false);
  const { auth, getRequestDataToggle, getIdCreateDoc, stateReducer, cleanIdSelectDoc } = useAuth();
  const [isBolsNumbers, setBolsNumbers] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSumBBLSgross, setSumBBLSgross] = useState(0);
  const cargoCaseBols = cargoCaseDocument[0]?.bols?.length;
  const [isShowRowBack, setShowRowBack] = useState(false);
  const [activeTableRowMenu, setActiveTableRowMenu] = useState(null);
  const [isListIdFiltredMan, setListIdFiltredMan] = useState([]);
  const [selectedCargoCaseMan, setSelectedCargoCaseMan] = useState([]);
  const [activeDocSetManTable, setActiveDocSetManTable] = useState(true);
  const [activeCreateManModal, setActiveCreateManModal] = useState(false);
  const [activeDocSetManNotFound, setActiveDocSetManNotFound] = useState(false);
  const [isShowAddBtn, setShowAddBtn] = useOnShowEditAddDocsButton(
    auth,
    cargoCaseDocument
  );
  const cargoCaseMan = useMemo(
    () => cargoCaseDocument.map((el) => el?.manifests),
    [cargoCaseDocument]
  );
  const [getListMan, setListMan] = useState([]);
  const [isFilterListMan, setFilterListMan] = useState([]);
  const [getCurrentMan, setCurrentMan] = useState([]);

  useEffect(() => {
    let isMounted = true;

    axiosGetListMan(axiosPrivate, isMounted, setListMan);
    cargoCaseMan.forEach((item, index) => {
      const getSelectManId = cargoCaseMan[index]?.map((el) => el?.id);
      isMounted && setListIdFiltredMan(getSelectManId);
    });

    return () => {
      isMounted = false;
    };
  }, [cargoCaseDocument]);

  useEffect(() => {
    let isMounted = true;

    if (activeDocSetManTable === true) {
      const filtredMans = [];
      isListIdFiltredMan.forEach((item, index) => {
        const itemMan = getListMan.find((el) => el?.id === item);
        filtredMans.push(itemMan);
        isMounted && setFilterListMan(filtredMans);
      });
      filtredArrayBolsSelectedMan(isFilterListMan, isMounted, setBolsNumbers);
    }

    return () => {
      isMounted = false;
    };
  }, [activeDocSetManTable, getListMan]);

  useEffect(() => {
    let isMounted = true;

    if (isNewDocCargoCase === true || cargoCaseMan[0].length === 0) {
      isMounted && setActiveDocSetManTable(false);
      isMounted && setActiveDocSetManNotFound(true);
    } else {
      isMounted && setActiveDocSetManTable(true);
      isMounted && setActiveDocSetManNotFound(false);
      axiosGetListMan(axiosPrivate, isMounted, setListMan);
      setSumBBLSgross(
        cargoCaseDocument[0]?.bols
          .map((el) => el?.bblsGross)
          .reduce((acc, el) => acc + el)
      );
    }

    return () => {
      isMounted = false;
    };
  }, [isNewDocCargoCase, cargoCaseMan, cargoCaseDocument]);

  function onShowCurrentDoc(id, i) {
    const currentCargoCaseMan = getListMan?.find((el) => el?.id === id);
    setActiveDocSetManTable(false);
    setSelectedCargoCaseMan([currentCargoCaseMan]);
    setShowRowBack(true);
    setBolsNumbers(isBolsNumbers[i]);
  }

  function onShowCreateManModal(
    activeNoLoadingOrder,
    cargoCaseDocId,
    cargoCaseBols
  ) {
    switch (activeNoLoadingOrder) {
      case false:
        setActiveCreateManModal(true);
        setErrorMessage("");
        break;
      case cargoCaseDocId !== undefined && cargoCaseBols !== 0:
        setActiveCreateManModal(true);
        setErrorMessage("");
        break;
      default:
        setErrorMessage("You need to create loading order and bill of lading!");
        setActiveCreateManModal(false);
    }
  }

  function onEditActiveMode() {
    if (editDoc === false) {
      setActiveCreateManModal(true);
      setEditDoc(true);
    }
  }

  function closeModal() {
    setActiveCreateManModal(false);
    setEditDoc(false);
  }

  function addManCargoCase(body, cargoCaseId, manId) {
    
    const changeBodyRequest = body.goods.map(function(item) {
      return {...item, id: 0}
    })

    const putBodyRequest = body.goods.map(function(item) {
      return item.edit === true ? {...item} : {...item, id: 0}
    })

    const updateDateBody = {...body, goods: changeBodyRequest}
    const putDateBody = {...body, goods: putBodyRequest}

    if (editDoc === true && manId !== undefined) {
      axiosPutUpdateBol(
        axiosPrivate,
        manId,
        putDateBody,
        getRequestDataToggle,
        getIdCreateDoc,
        cargoCaseId,
        setErrorMessage,
        setActiveCreateManModal,
        setEditDoc
      );
    } else {
      axiosPostAddNewMan(
        axiosPrivate,
        updateDateBody,
        getRequestDataToggle,
        getIdCreateDoc,
        cargoCaseId,
        setErrorMessage,
        setActiveCreateManModal
      );
    }
  }

  useEffect(() => {
    let isLoading = true;

    if (selectedCargoCaseMan[0]?.id !== undefined) {
      const currentCargoCaseMan = getListMan?.find(
        (el) => el?.id === selectedCargoCaseMan[0]?.id
      );
      isLoading && setActiveDocSetManTable(false);
      isLoading && setSelectedCargoCaseMan([currentCargoCaseMan]);
    }
    return () => {
      isLoading = false;
    };
  }, [cargoCaseDocument, getListMan]);

  const handleBackToTable = () => {
    setActiveDocSetManTable(true);
    setSelectedCargoCaseMan([]);
    setBolsNumbers([]);
    setShowRowBack(false);
  };

  // console.log(stateReducer.idSelectDoc)
  // console.log(getListMan)
  // console.log(isBolsNumbers)

  // function onSelectCurrentDoc(id) {
  //   const currentCargoCaseMan = getListMan[0]?.find((el => el?.id === id));
  //   const currentIndexCargoCaseMan = getListMan[0]?.findIndex((el => el?.id === currentCargoCaseMan.id));
  //   console.log(currentIndexCargoCaseMan)
  //   setActiveDocSetManTable(false);
  //   setSelectedCargoCaseMan([currentCargoCaseMan]);
  //   setShowRowBack(true);
  //   setBolsNumbers(isBolsNumbers[currentIndexCargoCaseMan]);
  // }

  // useEffect(() => {
  //   let isMounted = true;
  //   if (stateReducer?.idSelectDoc?.typeDoc === 'MAN' && stateReducer?.idSelectDoc?.idDoc !== undefined) {
  //     isMounted && onSelectCurrentDoc(stateReducer.idSelectDoc?.idDoc)
  //     // isMounted && cleanIdSelectDoc(stateReducer.idSelectDoc?.idDoc)
  //   }
  //   return () => {
  //     isMounted = false;
  //   }

  // },[stateReducer?.idSelectDoc])

  return (
    <div className="cargo-case-doc-set-man__container">
      <div className="cargo-case-doc-set-man__title">
        <div className="cargo-case-doc-set-man__title-row">
          {isShowRowBack ? (
            <div
              onClick={() => handleBackToTable()}
              className="cargo-case-doc-set-bol__title-row-back"
            >
              <img
                className="cargo-case-doc-set-bol__title-icon"
                src={rowBackIcon}
                alt={"icon row"}
              />
              <p className="cargo-case-doc-set-bol__title-name">
                Back to table
              </p>
            </div>
          ) : (
            <h4 className="cargo-case-doc-set-bol__title-name">MAN</h4>
          )}
        </div>
      </div>
      {activeDocSetManNotFound ? (
        <div className="cargo-case-doc-set-man__document-not-found">
          <CreateNewDocuments
            handeClickCreateNew={() =>
              onShowCreateManModal(
                activeNoLoadingOrder,
                cargoCaseDocId,
                cargoCaseBols
              )
            }
            hiddenUploadBtn={true}
            cargoCaseDocument={cargoCaseDocument}
            isNewDocCargoCase={isNewDocCargoCase}
          />
          <p className="cargo-case-doc-set-bol__document-not-found-error-message">
            {errorMessage}
          </p>
        </div>
      ) : (
        <div className="cargo-case-doc-set-man__table">
          {activeDocSetManTable ? (
            <div className="cargo-case-doc-set-man__table-block">
              <div className="cargo-case-doc-set-man__table-block-search-add-new">
                <div className="cargo-case-doc-set-man__search">
                  <Search value={filter} setValue={setFilter} />
                </div>
                {isShowAddBtn && (
                  <div
                    onClick={() => setActiveCreateManModal(true)}
                    className="cargo-case-doc-set-man__add-new-btn"
                  >
                    <img
                      className="cargo-case-doc-set-man__add-new-btn-icon"
                      src={addPlusIcon}
                      alt={"иконка плюс"}
                    />
                    <p className="cargo-case-doc-set-man__name-btn">Add MAN</p>
                  </div>
                )}
              </div>
              <div className="cargo-case-doc-set-man__table-header">
                <p>MAN No.</p>
                <p>B/L No.</p>
                <p>Port of loading</p>
                <p>Port of discharging</p>
                <p>Flag</p>
                <p>BBLS gross</p>
                <p>Carrier</p>
                <p>Status</p>
              </div>
              {cargoCaseMan[0]
                .filter((el) => el?.number?.includes(filter))
                .map((el, i) => {
                  return (
                    <div
                      onClick={() => onShowCurrentDoc(el?.id, i)}
                      key={el?.id}
                      className="cargo-case-doc-set-man__table-row"
                    >
                      <p>{el?.number}</p>
                      <p>{isBolsNumbers[i]?.toString()}</p>
                      <p>{el?.portOfLoadingName}</p>
                      <p>{el?.portOfDischargeName}</p>
                      <p>{el?.vessel?.country?.name}</p>
                      <p>{isSumBBLSgross}</p>
                      <p>{el?.shipowner?.name}</p>
                      <div className="cargo-case-table-row-status">
                        <img
                          className="cargo-case-table-row-status__icon-prepared"
                          src={findStatusDocument(el?.status)}
                          alt={"иконка подготовлен"}
                        />
                        {/* <img onClick={(e) => onHandleShowTableMenu(el?.id, activeTableRowMenu, setActiveTableRowMenu, e)}  className="cargo-case-table-row-status__icon-more-btn" src={moreBtnTableIcon} alt={'иконка показать больше'}/>
                                            <TableRowMenu
                                                index={el.id}
                                                activeTableRowMenu={activeTableRowMenu}
                                            /> */}
                      </div>
                    </div>
                  );
                })}
            </div>
          ) : (
            <>
              <SelectedDocSetMan
                selectedCargoCaseMan={selectedCargoCaseMan}
                isBolsNumbers={isBolsNumbers}
                cargoCaseDocId={cargoCaseDocId}
                onEditHandler={() => onEditActiveMode()}
              />
            </>
          )}
        </div>
      )}
      {activeCreateManModal && (
        <CreateDocSetManModal
          closeModal={closeModal}
          cargoCaseDocument={cargoCaseDocument}
          addManCargoCase={addManCargoCase}
          editDoc={editDoc}
          selectedCargoCaseMan={selectedCargoCaseMan}
        />
      )}
    </div>
  );
};
export default CargoCaseDocSetMan;
